import { createTheme } from '@mui/material';
export const FILLED_TEXTFIELD_THEME = createTheme({
    typography: {
        fontFamily: "'Open Sans', sans-serif"
    },
    components: {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: '#7b7a86',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    '&.Mui-focused': {
                        color: '#005F9E'
                    }
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    height: '48px'
                }
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: '#eeeeee'
                },
                underline: {
                    '&:before': {
                        borderBottom: '1px solid #009ad9'
                    },
                    '&:hover:before': {
                        borderBottomColor: '#009ad9'
                    },
                    '&:after': {
                        borderBottom: '2px solid #009ad9'
                    }
                }
            }
        }
    }
});
